import { useAppSelector } from '@/redux/hooks';
import React, { useEffect } from 'react';
import SEO from '@/helpers/seo';
import { NextPageContext } from 'next';
import UserStorage from '@/storages/user-storage';
import router from 'next/router';
import api from '@/services/fidelity/api';

function getWindowDimensions() {
  const { innerHeight: height } = window;
  return height;
}

export default function LinksPage({ seo }: any) {
  const { client } = useAppSelector((state) => state.auth);
  
  useEffect(() => {
    if(client != null){
      api.defaults.headers['API-TOKEN'] = `${client.token}`;
      // Perform localStorage action
      if(UserStorage.GetFidelityLogin()){
        router.push('/fidelidade/pontuacao');
      } else {
        router.push('/fidelidade/login');
      }
    }
  }, [client])
 
  return (
    <>
    </>
  );
}

export const getServerSideProps = async (context: NextPageContext) => {
  let seo = await SEO(context);
  return seo;
};

